import { Auth } from 'aws-amplify';

export const getAuthToken = async () => {
  try {
    const data = await Auth.currentSession();
    return data.getIdToken().getJwtToken();
  } catch (error) {
    throw Error('Error getting token');
  }
};